import { initialState } from '@/features/rc/rcSlice';
import { RcState } from '@/features/rc/types';

export const loadRcState = (): RcState => {
  try {
    const serializedState = localStorage.getItem('rcState');
    if (!serializedState) return initialState;
    return JSON.parse(serializedState);
  } catch (e) {
    console.warn('Failed to load RC state from localStorage:', e);
    return initialState;
  }
};

export const saveRcState = (state: RcState) => {
  try {
    if (!state) return;
    const serializedState = JSON.stringify(state);
    localStorage.setItem('rcState', serializedState);
  } catch (e) {
    console.warn('Failed to save RC state:', e);
  }
};
